import React, { useEffect, useState } from 'react';
import { Card } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Input } from '../../components/ui/input';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '../../components/ui/select';
import { api } from '../../api/client';

const statusColor = (s) => s === 'Paid' ? 'border-emerald-600 text-emerald-400' : s === 'Pending' ? 'border-amber-600 text-amber-400' : s === 'Refunded' ? 'border-rose-600 text-rose-400' : 'border-zinc-700 text-zinc-400';

const AdminOrders = () => {
  const [list, setList] = useState([]);
  const [q, setQ] = useState('');
  const [status, setStatus] = useState('all');

  useEffect(() => {
    api.listOrders({ status, q })
      .then(setList)
      .catch((err) => { console.error('listOrders failed:', err); setList([]); });
  }, [status, q]);

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap gap-3 items-center">
        <Input placeholder="Search by order number or email" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-xs bg-transparent border-zinc-800" />
        <Select value={status} onValueChange={setStatus}>
          <SelectTrigger className="max-w-[180px] bg-transparent border-zinc-800"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All statuses</SelectItem>
            <SelectItem value="Pending">Pending</SelectItem>
            <SelectItem value="Paid">Paid</SelectItem>
            <SelectItem value="Failed">Failed</SelectItem>
            <SelectItem value="Refunded">Refunded</SelectItem>
            <SelectItem value="Canceled">Canceled</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <Card className="bg-zinc-950 border-zinc-900 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-zinc-900/60">
            <tr className="text-left text-zinc-400">
              <th className="p-3">Order</th><th className="p-3">Email</th><th className="p-3">Date</th><th className="p-3">Items</th><th className="p-3">Total</th><th className="p-3">Payment</th><th className="p-3">Country</th><th className="p-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {list.length === 0 && <tr><td colSpan={8} className="p-6 text-center text-zinc-500">No orders yet</td></tr>}
            {list.map((o) => (
              <tr key={o.id} className="border-t border-zinc-900 hover:bg-zinc-900/30">
                <td className="p-3 text-[#d4af37]">{o.order_number}</td>
                <td className="p-3 text-zinc-200">{o.email}</td>
                <td className="p-3 text-zinc-300">{(o.created_at||'').slice(0,10)}</td>
                <td className="p-3 text-zinc-300">{(o.items||[]).reduce((s,i) => s + i.qty, 0)}</td>
                <td className="p-3 text-zinc-100">€{Number(o.total||0).toFixed(2)}</td>
                <td className="p-3 text-zinc-300">{o.payment_method} {o.payment_provider ? `(${o.payment_provider})` : ''}</td>
                <td className="p-3 text-zinc-300">{o.country || '—'}</td>
                <td className="p-3"><Badge variant="outline" className={statusColor(o.status)}>{o.status}</Badge></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>

      <p className="text-zinc-500 text-xs">Customer pays in iDEAL/Card/Crypto → you receive the payout in BTC/ETH at your configured wallet (see Payments tab).</p>
    </div>
  );
};

export default AdminOrders;
